<!-- src/components/Recaptcha.vue -->
<template>
  <div class="captcha-box">
    <canvas id="captchaCanvas" width="200" height="50"></canvas>
    <button type="button" class="refresh-captcha" @click="refreshCaptcha">
      <span class="reload">&#10227;</span>
    </button>
  </div>
</template>

<script lang="ts" setup>
import { defineEmits, onMounted } from "vue";

const emit = defineEmits<{
  (e: 'captcha-updated', captcha: string): void;
}>();

let captchaText = "";

const generateRandomString = (length: number) => {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const drawCaptcha = () => {
  const canvas = document.getElementById("captchaCanvas") as HTMLCanvasElement;
  const context = canvas.getContext("2d");
  if (context) {
    context.clearRect(0, 0, canvas.width, canvas.height);
    captchaText = generateRandomString(6);
    context.fillStyle = "#000";
    context.font = "24px Arial";
    context.fillText(captchaText, 50, 30);
    context.strokeStyle = "#A9A9A9";
    context.lineWidth = 1;
    for (let i = -canvas.height; i < canvas.width; i += 10) {
      context.beginPath();
      context.moveTo(i, 0);
      context.lineTo(i + canvas.height, canvas.height);
      context.stroke();
    }
    for (let i = 0; i < canvas.width + canvas.height; i += 10) {
      context.beginPath();
      context.moveTo(i, 0);
      context.lineTo(i - canvas.height, canvas.height);
      context.stroke();
    }
    emit('captcha-updated', captchaText);
  }
};

const refreshCaptcha = () => {
  drawCaptcha();
};

onMounted(() => {
  drawCaptcha();
});
</script>

<script lang="ts">
export default { name: "ReCaptcha" };
</script>

<style scoped>
.refresh-captcha {
  background: none;
  border: none;
  font-size: 24px;
  margin-left: 10px;
  cursor: pointer;
  color: #007bff;
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
}

.captcha-container {
  position: relative;
  margin-top: 15px;
}

.captcha-box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 200px;
  height: 50px;
  border-radius: 4px;
}

#captchaCanvas {
  width: 200px;
  height: 50px;
  background-color: transparent;
  position: absolute;
}
</style>
